import React, { useEffect, useState } from "react";
import CustomInput from "../CustomInput";
import ModalStructure from "../ModalStructure";
import {
  createProduct,
  getAllSubClasses,
  getImagesBySubClass,
  handleBulkCreate,
  updateProduct,
  uploadProductImage,
} from "../../services/products";
import { FaTrash } from "react-icons/fa6";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";
import SpecsModal from "./modals/SpecsModal";
import { FaList, FaRegCheckCircle } from "react-icons/fa";
import { colorOptions } from "../../utils/other";
import { MdOutlineErrorOutline } from "react-icons/md";

const statusOptions = [
  { text: "Disponible", value: "available" },
  { text: "No disponible", value: "unavailable" },
  { text: "Reservado", value: "reserved" },
  { text: "Vendido", value: "sold" },
  { text: "Otro", value: "other" },
];

//modificar en base a clase y subclases
const ProductForm = ({
  handleClose,
  loadToParent,
  prevData,
  //  subClasses,
  //uploadParentSC,
}) => {
  //prev data se recibe en caso necesite se realice alguna actualizacion
  //const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [enableOffer, setEnableOffer] = useState(false);
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);
  const [showSpecsModal, setShowSpecsModal] = useState(false);
  const [subClassesOptions, setSubClassesOptions] = useState([]);
  const [images, setImages] = useState([]);

  const [dataIsValid, setDataIsValid] = useState(true);

  const [formData, setFormData] = useState({
    subClass: prevData?.subClass.id || "",
    code: prevData?.code || "",
    status: prevData?.status || "", //validar en el back
    name: prevData?.name || "",
    mainImage: prevData?.mainImage.id || "",
    images: prevData?.images?.map((img) => img.id) || [],
    entryDate: prevData?.entryDate ? prevData?.entryDate.split("T")[0] : "",
    providerName: prevData?.providerName || "",
    providerRuc: prevData?.providerRuc || "",
    mainSpecs: prevData?.mainSpecs || [],
    otherSpecs: prevData?.otherSpecs || [],
    purchasePrice: prevData?.purchasePrice || "",
    salePrice: prevData?.salePrice || "",
    inOffer: prevData?.inOffer || false,
    offerDiscount: prevData?.offerDiscount || "",
    offerEndDate: prevData?.offerEndDate
      ? prevData.offerEndDate.split("T")[0]
      : "",
    postSaleWait: prevData?.postSaleWait || "",
    //    mainImage:prevData.mainImage || "" //debe ser un id
  });

  useEffect(() => {
    let result = validateData(formData);
    setDataIsValid(result);
  }, [formData]);

  const [subClasses, setSubClasses] = useState([]);

  useEffect(() => {
    const fetchAllSubClasses = async () => {
      try {
        const { docs } = await getAllSubClasses();
        setSubClasses(docs);
        setSubClassesOptions(
          docs.map((sc) => ({ text: sc.name, value: sc.id }))
        );
      } catch {
        console.log("error");
        Notification({
          title: "Error",
          text: "Algo salió mal...",
          type: "Error",
        });
      }
    };
    fetchAllSubClasses();
  }, []);

  useEffect(() => {
    if (formData.subClass != "") {
      const fetchImages = async () => {
        try {
          if (prevData) {
            if (prevData.subClass.id != formData.subClass) {
              let temp = { ...formData };
              temp.mainImage = null;
              temp.images = [];
              setFormData(temp);
              setImages([]);
            }
          } else {
            let temp = { ...formData };
            temp.mainImage = "";
            temp.images = [];
            temp.mainSpecs = [];
            temp.otherSpecs = [];
            setFormData(temp);
            setImages([]);
          }
          const { docs, totalDocs } = await getImagesBySubClass(
            formData.subClass
          );
          if (totalDocs === 0) {
            Notification({
              title: "Aviso",
              text: "No hay imágenes para esta subclase",
              type: "Info",
            });
          } else if (docs.filter((img) => img.isMainImage).length === 0) {
            Notification({
              title: "Aviso",
              text: "No hay imágenes principales para esta subclase",
              type: "Info",
            });
          }
          setImages(docs);
        } catch (err) {
          IS_LOCAL_ENV && console.error(err);
        }
      };
      fetchImages();
    }
  }, [formData.subClass]);

  const validateData = (data) => {
    if (
      data?.code?.trim() == "" ||
      data?.name?.trim() == "" ||
      data?.subClass?.trim() == "" ||
      data?.status == "" ||
      data?.entryDate == "" ||
      data?.providerName?.trim() == "" ||
      data?.providerRuc?.trim() == "" ||
      data?.purchasePrice == "" ||
      data?.salePrice == "" ||
      data?.postSaleWait == "" ||
      //data?.mainSpecs?.length == 0 || test
      data?.mainImage == "" ||
      (data?.mainSpecs?.length > 0 &&
        data?.mainSpecs?.some(
          (spec) => spec.name.trim() == "" || spec.values.length == 0
        )) ||
      (data.inOffer && data?.offerDiscount == "" && data?.offerEndDate == "")
    ) {
      return false;
    } else {
      return true;
    }
  };

  const onChangeSomeValue = (e, field, subfield) => {
    let temp = { ...formData };
    if (subfield) temp[field][subfield] = e.target.value;
    else temp[field] = field == "inOffer" ? e.target.checked : e.target?.value;
    setFormData(temp);
  };

  const onChangeProductImage = (type, id) => {
    let temp = { ...formData };
    if (type == "mainImage") temp.mainImage = id;
    else {
      if (!temp.images.includes(id)) temp.images.push(id);
      else temp.images = temp.images.filter((img) => img != id);
    }
    setFormData(temp);
  };

  const uploadSpecs = (specs) => {
    //setear data directamente
    setFormData({
      ...formData,
      mainSpecs: specs.mainSpecs,
      otherSpecs: specs.otherSpecs,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setUploading(true);
    if (!validateData(formData)) {
      setUploading(false);
      Notification({
        title: "Operación inválida",
        text: "Datos incompletos",
        type: "Error",
      });
      return;
    } else {
      const loadData = async () => {
        try {
          //============configurar props=============
          //eliminar ids
          let mainSpecs_ = formData.mainSpecs.map((spec) => ({
            name: spec.name,
            values: spec.values.map((val) => ({
              value: val.value,
              code: val.code,
            })),
          }));
          let otherSpecs_ = formData.otherSpecs.map((spec) => ({
            name: spec.name,
            value: spec.value,
          }));

          let props = {
            ...formData,
            purchasePrice: parseFloat(formData.purchasePrice),
            salePrice: parseFloat(formData.salePrice),
            mainSpecs: mainSpecs_,
            otherSpecs: otherSpecs_,
            inOffer: formData.inOffer,
            offerDiscount: formData.inOffer
              ? parseFloat(formData.offerDiscount)
              : null,
            offerEndDate: formData.inOffer
              ? new Date(formData.offerEndDate)
              : null,
          };

          IS_LOCAL_ENV && console.log(props);

          //============actualizar o crear producto=============
          //if (newMainImage != null) props["mainImage"] = newMainImage.id;
          IS_LOCAL_ENV && console.log(props);
          const response = prevData
            ? await updateProduct(prevData.id, props)
            : await handleBulkCreate([props]); //para verificar los mainSpecs
          IS_LOCAL_ENV &&
            console.log(
              "producto actualizado o creado: ",
              response?.createdProducts?.[0] || response?.doc
            );
          loadToParent(
            response?.createdProducts?.[0] || response?.doc,
            prevData?.id || null
          );
          Notification({
            title: "Operación completada",
            text: `Producto ${
              prevData ? "actualizado" : "creado"
            } exitosamente`,
            type: "Success",
          });
          //=======================================================
          setUploading(false);
          handleClose();
        } catch (err) {
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
          IS_LOCAL_ENV && console.error(err);
        }
      };

      loadData();
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-y-4  oveflow-y-scroll">
      <h1 className="font-poppins font-bold text-dark-green text-2xl">
        {prevData ? "Actualizar producto" : "Agregar producto"}
      </h1>
      <form className="w-full p-2 flex flex-wrap items-start gap-2">
        <CustomInput
          customMaxW={"max-w-[300px]"}
          title="Código"
          value={formData.code}
          onChange={(e) => onChangeSomeValue(e, "code")}
          placeholder="1234..."
          inputType="text"
          required={true}
        />

        <CustomInput
          customMaxW={"max-w-[300px]"}
          title="Nombre"
          value={formData.name}
          onChange={(e) => onChangeSomeValue(e, "name")}
          placeholder="Orquídea amarilla..."
          inputType="text"
          required={true}
        />

        {!prevData && (
          <CustomInput //si estoy editando un product, no deberia poder cambiar su subClase, porque seria crear otro practicamente
            customMaxW={"max-w-fit"}
            title="Subclase"
            inputType="select"
            selectProps={{
              options: subClassesOptions,
              value: formData.subClass,
              setValue: (e) => onChangeSomeValue(e, "subClass"),
              isTableSelect: true,
              placeholder: "SubClase",
              required: true,
              isInputChild: true,
              initialValue: prevData ? prevData.subClass.id : null,
            }}
            required={true}
          />
        )}

        <CustomInput
          customMaxW={"max-w-fit"}
          title="Estado"
          inputType="select"
          selectProps={{
            options: statusOptions,
            value: formData.status,
            setValue: (e) => onChangeSomeValue(e, "status"),
            isTableSelect: true,
            placeholder: "seleccionar",
            required: true,
            isInputChild: true,
            initialValue: prevData ? prevData.status : null,
          }}
          required={true}
        />

        {/*Image de producto, verificar */}
        <CustomInput
          customMaxW={"max-w-[300px]"}
          title="Fecha de ingreso"
          value={formData.entryDate}
          onChange={(e) => onChangeSomeValue(e, "entryDate")}
          placeholder=""
          inputType="date"
          required={true}
        />
        <CustomInput
          customMaxW={"max-w-[300px]"}
          title="Nombre proveedor"
          value={formData.providerName}
          onChange={(e) => onChangeSomeValue(e, "providerName")}
          placeholder="Herwi..."
          inputType="text"
          required={true}
        />
        <CustomInput
          customMaxW={"max-w-[200px]"}
          title="RUC"
          value={formData.providerRuc}
          onChange={(e) => onChangeSomeValue(e, "providerRuc")}
          placeholder="12345..."
          inputType="number"
          required={true}
        />
        <CustomInput
          customMaxW={"max-w-[220px]"}
          title="Precio de compra"
          value={formData.purchasePrice}
          onChange={(e) => onChangeSomeValue(e, "purchasePrice")}
          placeholder="100 ..."
          inputType="number"
          required={true}
        />
        <CustomInput
          customMaxW={"max-w-[220px]"}
          title="Precio de venta"
          value={formData.salePrice}
          onChange={(e) => onChangeSomeValue(e, "salePrice")}
          placeholder="150 ..."
          inputType="number"
          required={true}
        />
        <CustomInput
          customMaxW={"max-w-[260px]"}
          title="Espera post venta(días)"
          value={formData.postSaleWait}
          onChange={(e) => onChangeSomeValue(e, "postSaleWait")}
          placeholder="x días"
          inputType="number"
          required={true}
        />
        {subClasses.length > 0 && (
          <button
            className={`${
              formData.subClass != ""
                ? "bg-dark-green hover:bg-accent-green"
                : "bg-light-gray cursor-not-allowed"
            } flex items-center text-base text-white rounded-full  px-6 py-4  font-poppins text-nowrap `}
            onClick={(e) => {
              if (formData.subClass == "") return;
              e.preventDefault();
              setShowSpecsModal(true);
            }}
          >
            Especificaciones &nbsp;{" "}
            {
              //formData?.mainSpecs?.length > 0 test
              //&& test
              !formData?.mainSpecs?.some(
                (spec) => spec.name.trim() == "" || spec.values.length == 0
              ) ? (
                <FaRegCheckCircle />
              ) : (
                <MdOutlineErrorOutline />
              )
            }
          </button>
        )}
        {images && (
          <button
            className={`${
              formData.subClass != "" && images.length > 0
                ? "bg-dark-green hover:bg-accent-green"
                : "bg-light-gray cursor-not-allowed"
            } flex items-center text-base text-white rounded-full  px-6 py-4  font-poppins text-nowrap `}
            onClick={(e) => {
              e.preventDefault();
              setShowImagesModal(true);
            }}
            disabled={formData.subClass == "" || images.length == 0}
          >
            Imágenes &nbsp;{" "}
            {formData?.mainImage != "" ? (
              <FaRegCheckCircle />
            ) : (
              <MdOutlineErrorOutline />
            )}
          </button>
        )}
        <div className="flex flex-col px-4 w-full">
          <span className="mt-2 font-poppins font-bold">
            <input
              type="checkbox"
              checked={formData.inOffer}
              onChange={(e) => onChangeSomeValue(e, "inOffer")}
              className=" rounded-[2px] checked:bg-accent-green focus:ring-transparent"
            />
            &nbsp;Oferta
          </span>
          <div className="flex flex-wrap items-center gap-x-2">
            {formData.inOffer && (
              <CustomInput
                customMaxW={"max-w-[200px]"}
                title="Descuento %"
                value={formData.offerDiscount}
                onChange={(e) => onChangeSomeValue(e, "offerDiscount")}
                placeholder="20"
                inputType="number"
                required={true}
              />
            )}
            {formData.inOffer && (
              <CustomInput
                customMaxW={"max-w-[220px]"}
                title="Fecha fin oferta"
                value={formData.offerEndDate}
                onChange={(e) => onChangeSomeValue(e, "offerEndDate")}
                placeholder="some date"
                inputType="date"
                required={true}
              />
            )}
          </div>
        </div>
      </form>
      {showSpecsModal && (
        <SpecsModal
          handleCloseModal={() => {
            setShowSpecsModal(false);
          }}
          _data={
            formData.mainSpecs.length > 0
              ? {
                  mainSpecs: formData.mainSpecs,
                  otherSpecs: formData.otherSpecs,
                }
              : null
          }
          editable={true}
          uploadParent={(newSpecs) => uploadSpecs(newSpecs)}
          subClass={subClasses.filter((sc) => sc.id == formData.subClass)[0]}
          handleClose={() => setShowSpecsModal(false)}
          loadToParent={(newSpecs) => uploadSpecs(newSpecs)}
        />
      )}
      {showImagesModal && (
        <ModalStructure handleCloseModal={() => setShowImagesModal(false)}>
          <div className="flex flex-col w-full gap-2">
            {/**Imágenes principales */}
            <div className="flex flex-col w-full gap-2">
              <h3 className="w-full text-center font-poppins text-lg">
                Seleccionar imagen principal
              </h3>
              <div className="flex flex-wrap w-full gap-4 p-2 bg-green-50 rounded-xl justify-center">
                {images
                  .filter((_img) => _img.isMainImage)
                  .map((img) => (
                    <div
                      className={`w-[150px] h-[150px] rounded-md overflow-hidden relative ${
                        img.id == formData.mainImage
                          ? "border-blue-600 border-[4px] p-1"
                          : ""
                      } `}
                      key={img.id}
                      onClick={() => onChangeProductImage("mainImage", img.id)}
                    >
                      <img
                        className="w-full h-full object-cover object-center"
                        src={`${process.env.REACT_APP_SERVER}${img.url}`}
                      />
                    </div>
                  ))}
              </div>
            </div>
            {/**Imágenes secundarias */}
            <div className="flex flex-col w-full gap-2">
              <h3 className="w-full text-center font-poppins text-lg">
                Seleccionar imagenes secundarias
              </h3>
              <div className="flex flex-wrap w-full gap-4 p-2 bg-green-50 rounded-xl justify-center">
                {images
                  .filter((_img) => !_img.isMainImage)
                  .map((img) => (
                    <div
                      className={`w-[150px] h-[150px] rounded-md overflow-hidden relative
                        ${
                          formData.images.includes(img.id)
                            ? "border-blue-600 border-[4px] p-1"
                            : ""
                        }
                        `}
                      key={img.id}
                      onClick={() => onChangeProductImage("images", img.id)}
                    >
                      <img
                        className="w-full h-full object-cover object-center"
                        src={`${process.env.REACT_APP_SERVER}${img.url}`}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </ModalStructure>
      )}
      <button
        className={` w-fit  text-base rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
          uploading || !dataIsValid
            ? "bg-light-gray cursor-not-allowed"
            : "hover:bg-accent-green bg-dark-green"
        }`}
        disabled={uploading || !dataIsValid}
        type="submit"
        onClick={handleSubmit}
      >
        <div className="flex flex-row items-center">
          <span className="text-nowrap text-xl">Guardar</span>
        </div>
      </button>
    </div>
  );
};

export default ProductForm;
